import { get as _get } from 'lodash';
import { v4 as uuid } from 'uuid';
import { createMockSimpleApiResponse, getMockPolicyData, isMockModeEnabled } from '../utils/mockDataHelper';

export async function getPolicy(
  urlKey: string,
  sessionId: string,
  custKey: string,
  policyNumber: string,
  partnerId: string,
  isSBSS: boolean,
  isE1P: boolean
) {
  // If in mock mode, return mock policy data
  if (isMockModeEnabled()) {
    console.log('🔧 Mock Mode: Using mock product-context data');

    // Simulate network delay
    await new Promise((resolve) => setTimeout(resolve, 300));

    const mockData = await getMockPolicyData(policyNumber);
    return createMockSimpleApiResponse(mockData);
  }

  try {
    const headers = new Headers();
    headers.append('urlid', urlKey);
    headers.append('afe-session-id', sessionId);
    headers.append('Authorization', 'Bearer ' + custKey);
    headers.append('content-type', 'application/json');
    headers.append('afe-trace-id', uuid());

    if (isE1P) {
      headers.append('isE1P', 'true');
    }

    if (isSBSS) {
      headers.append('partner-id', 'sbss');
    } else {
      headers.append('partner-id', partnerId);
    }

    const URI = `${process.env['NX_PRODUCT_CONTEXT_API_URL']}products/partners/${policyNumber}`;

    const response = await fetch(URI, {
      method: 'GET',
      headers: headers,
    });
    const responseData = await response.json();
    const { statusCode } = responseData;
    const { error } = responseData;
    const { message } = responseData;
    if (_get(responseData, 'status.statusCode', '') >= 200) {
      return responseData;
    } else {
      return { error, statusCode, message };
    }
  } catch (error) {
    console.log('getPolicy:error', error);
    return error;
  }
}
